/*
 * variant-price-update.js
 *
 * Keeps the sticky add-to-cart bar's price in sync with the main product price.
 *
 * Why this exists: the product template re-renders .product-price--original and
 * .product-price--compare when a shopper picks a variant, but the sticky bar keeps
 * whatever was server-rendered on page load. Selecting the 30lb size on a hard wax
 * page left the sticky bar advertising the 2.2lb price while the cart charged the
 * 30lb price.
 *
 * This mirrors the theme's own rendered markup into the sticky bar rather than
 * recalculating anything, so it cannot display a price the theme did not already
 * produce. The sticky "Add" button triggers the main product form, so the variant
 * added to cart was always correct - this only fixes what the shopper sees.
 */
(function () {
  'use strict';

  var STICKY = '.product-sticky-atc';
  var SEL = {
    mainSale: '.product-price--original',
    mainCompare: '.product-price--compare',
    stickyPrice: '.product-sticky-atc__price',
    stickySale: '.product-sticky-atc__sale',
    stickyCompare: '.product-sticky-atc__compare'
  };

  // Pick the price node that belongs to the main product block, never one that
  // lives inside the sticky bar itself.
  function mainNode(selector) {
    var nodes = document.querySelectorAll(selector);
    for (var i = 0; i < nodes.length; i++) {
      if (!nodes[i].closest(STICKY)) return nodes[i];
    }
    return null;
  }

  function sync() {
    var mainSale = mainNode(SEL.mainSale);
    var stickyPrice = document.querySelector(SEL.stickyPrice);
    if (!mainSale || !stickyPrice) return;

    var stickySale = stickyPrice.querySelector(SEL.stickySale);
    if (stickySale && stickySale.innerHTML !== mainSale.innerHTML) {
      stickySale.innerHTML = mainSale.innerHTML;
    }

    var mainCompare = mainNode(SEL.mainCompare);
    var compareHTML = mainCompare ? mainCompare.innerHTML.trim() : '';
    var stickyCompare = stickyPrice.querySelector(SEL.stickyCompare);

    if (stickyCompare) {
      if (stickyCompare.innerHTML !== compareHTML) stickyCompare.innerHTML = compareHTML;
      stickyCompare.setAttribute('aria-hidden', compareHTML ? 'false' : 'true');
    } else if (compareHTML) {
      // Shopper moved from a full-price variant to a discounted one and the
      // compare element was never server-rendered. Create it.
      var span = document.createElement('span');
      span.className = 'product-sticky-atc__compare';
      span.innerHTML = compareHTML;
      stickyPrice.appendChild(span);
    }
  }

  function start() {
    var mainSale = mainNode(SEL.mainSale);
    if (!mainSale || !document.querySelector(SEL.stickyPrice)) return;

    sync();

    if (typeof MutationObserver !== 'function') return;
    var observer = new MutationObserver(sync);
    var opts = { childList: true, subtree: true, characterData: true };

    observer.observe(mainSale, opts);
    var mainCompare = mainNode(SEL.mainCompare);
    if (mainCompare) observer.observe(mainCompare, opts);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
